import React from "react";
import Tag from "components/Tag/tag";
import { getStatusColor } from "common/helpers/reportsHelper";
import { ReportStatus } from "models/ReportStatus";
import { useRole } from "hooks/useRole";

type TagProps = {
  tags: ReportStatus[];
  onchange?: (tag: ReportStatus) => void;
  selectedTags: number[];
};

const Tags = (props: TagProps) => {
  const role = useRole();

  const { tags, onchange, selectedTags } = props;

  const renderTags = () => {
    return tags
      ? tags.map((tag: ReportStatus) => {
          return (
            <Tag
              key={tag.type}
              text={tag.type}
              active={selectedTags?.some((id) => tag.ids.includes(id))}
              color={getStatusColor(tag.ids?.[0], role)}
              onClickHandle={() => {
                onchange && onchange(tag);
              }}
            />
          );
        })
      : null;
  };

  return <div className="tagsContainer">{renderTags()}</div>;
};

export default Tags;
